import { BookingQualificationRequirements } from "@justhome/api-core";
import {
  needsEmployment,
  needsEquity,
  needsPropertyViewingStatus,
  needsIncome,
  needsProperty,
  needsResidence,
} from "../context/guards";
import { QualificationStateId } from "../context/machine";

const normalizeStepId = (
  stepId: QualificationStateId,
): QualificationStateId | null => {
  if (stepId === "disqualified" || stepId === "reconfirmationComplete") {
    return null;
  }
  if (stepId === "calendarComplete") {
    return null;
  }
  if (stepId === "start") {
    return null;
  }
  if (stepId === "calendar") {
    return "calendar";
  }
  if (stepId.endsWith("Saving")) {
    return stepId.replace("Saving", "") as QualificationStateId;
  }
  return stepId;
};

export const getTotalSteps = (
  requirements: BookingQualificationRequirements | undefined,
): number => {
  if (!requirements) {
    return 0;
  }
  let count = 0;
  if (needsProperty(requirements)) count++;
  if (needsIncome(requirements)) count++;
  if (needsEquity(requirements)) count++;
  if (needsResidence(requirements)) count++;
  if (needsEmployment(requirements)) count++;
  if (needsPropertyViewingStatus(requirements)) count++;
  return count;
};

export const getCurrentStepIndex = (
  stepId: QualificationStateId,
  requirements: BookingQualificationRequirements | undefined,
): number | null => {
  if (!requirements) {
    return null;
  }
  const normalizedStepId = normalizeStepId(stepId);
  if (normalizedStepId === null) {
    return null;
  }

  const neededSteps: QualificationStateId[] = [];
  if (needsProperty(requirements)) neededSteps.push("property");
  if (needsIncome(requirements)) neededSteps.push("income");
  if (needsEquity(requirements)) neededSteps.push("equity");
  if (needsResidence(requirements)) neededSteps.push("residence");
  if (needsEmployment(requirements)) neededSteps.push("employment");
  if (needsPropertyViewingStatus(requirements))
    neededSteps.push("propertyViewingStatus");

  const index = neededSteps.indexOf(normalizedStepId);
  return index >= 0 ? index : null;
};
